/* eslint-disable no-prototype-builtins */
/* eslint-disable import/no-default-export */
class CountDownUtil {
  constructor() {
    this.timers = {}
    this.globalTimer = null
  }

  addCountDown(key, seconds, callback) {
    if (!this.timers[key]) {
      const targetTime = Date.now() + seconds * 1000
      this.timers[key] = { targetTime, callback }
      if (!this.globalTimer) {
        this.startGlobalTimer()
      }
    }
  }

  removeCountDown(key) {
    if (this.timers[key]) {
      delete this.timers[key]
      if (Object.keys(this.timers).length === 0 && this.globalTimer) {
        clearInterval(this.globalTimer)
        this.globalTimer = null
      }
    }
  }

  clearAll() {
    if (this.globalTimer) {
      clearInterval(this.globalTimer)
      this.globalTimer = null
    }
    this.timers = {}
  }

  startGlobalTimer() {
    this.globalTimer = setInterval(() => {
      for (const key in this.timers) {
        if (this.timers.hasOwnProperty(key)) {
          const { targetTime, callback } = this.timers[key]
          const now = Date.now()
          const remainingTime = Math.max(
            0,
            Math.ceil((targetTime - now) / 1000)
          )

          if (remainingTime === 0) {
            // eslint-disable-next-line standard/no-callback-literal
            callback(0)
            delete this.timers[key]
          } else {
            callback(remainingTime)
          }
        }
      }

      if (Object.keys(this.timers).length === 0) {
        clearInterval(this.globalTimer)
        this.globalTimer = null
      }
    }, 1000)
  }
}

export default new CountDownUtil()
